export default __webpack_public_path__ + "static/media/scroll-to-top.b6c393a8.png";